import { IBookmarkedEntitiesType, IEntityType } from '../types'

export const filterNonAgentVisibleEntitiesFromBookmark = (
  bookmarkEntities?: IBookmarkedEntitiesType[],
  allEntities?: IEntityType[]
) => {
  if (!bookmarkEntities) return []
  if (!allEntities) return []
  return bookmarkEntities.filter((be) =>
    allEntities.some((e) => {
      return e.id === be.id && e.agent_visibility
    })
  )
}
